import { render, staticRenderFns } from "./CardTransferType.vue?vue&type=template&id=1369cb30&scoped=true&"
import script from "./CardTransferType.vue?vue&type=script&lang=js&"
export * from "./CardTransferType.vue?vue&type=script&lang=js&"
import style0 from "./CardTransferType.vue?vue&type=style&index=0&id=1369cb30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1369cb30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VContainer,VIcon})
